import(/* webpackMode: "eager" */ "D:\\Verasoft\\KORVUE-XL\\rxl\\src\\app\\(auth)\\login\\page.tsx");
